<template>
  <section v-if="content" id="workshopIntro" class="workshop-intro">
    <h2 class="section__title section__title-underline -center -workshop">{{ content.title }}</h2>
    <p class="workshop-intro__content">
      {{ content.description }}
    </p>
    <div class="workshop-intro__list">
      <router-link
        v-for="(workshop, workshopKey) in content.workshops"
        :key="workshopKey"
        :to="`#${workshop.anchor}`"
        class="workshop-intro__item"
      >
        <img :src="workshop.icon" alt="" class="workshop-intro__image" />
        <h3>{{ workshop.title }}</h3>
        <Icon id="long-arrow" class="workshop-intro__icon" />
      </router-link>
    </div>
  </section>
</template>

<script>
import { Icon } from '@/components/global'

export default {
  name: 'WorkshopIntroSection',
  components: { Icon },
  props: {
    content: {
      type: Object,
      default: null
    }
  }
}
</script>
